<script setup lang="ts">
import { useRouter } from 'vue-router';

const router = useRouter();
</script>

<template>
  <v-list class="py-0" aria-label="system administration list">
    <v-list-item color="primary" rounded="0" @click="router.push('/admin/systeme/inscription')">
      <template #prepend>
        <v-icon size="small">fas fa-user-plus</v-icon>
      </template>
      <v-list-item-title class="text-body-2">Inscription</v-list-item-title>
    </v-list-item>
  </v-list>
</template>
